import { useQuery } from '@tanstack/react-query';

import { useOrpc } from '@/_shared/hooks/useOrpc';

/** Returns whether the current workspace allows publishing dashboards to the
 * public (anonymous) URL. The Settings UI flips this; the share popover and
 * publish dialog read it to disable controls / show the "frozen" banner when
 * the workspace admin has turned sharing off. */
export function usePublicSharingPolicy(): { publicSharingEnabled: boolean; isLoading: boolean } {
  const orpc = useOrpc();
  const { data, isLoading } = useQuery(orpc.settings.get.queryOptions({ input: {} }));
  return {
    publicSharingEnabled: data?.settings.publicSharingEnabled ?? false,
    isLoading,
  };
}
